<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>Relatório LAI</span>
                </h4>
                <b-row v-if="exibirSelect">
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label
                                for="selectListaContratos"
                                >Contrato</label
                            >
                            <model-list-select
                                id="selectListaContratos"
                                :list="listaContratos"
                                v-model="contrato"
                                option-value="idContrato"
                                option-text="textoFormatado"
                                placeholder="Selecione um contrato"
                                :isDisabled="todosContratos"
                            ></model-list-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label for="dataDe">Data Inicial</label>
                            <date-picker
                                id="dataDe"
                                v-model="dataDe"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label for="dataAte">Data Final</label>
                            <date-picker
                                id="dataAte"
                                v-model="dataAte"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                                :state="validacaoData"
                            ></date-picker>
                            <b-form-invalid-feedback v-if="!validacaoData">
                                A data final deve ser maior ou igual à data inicial
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col md="2">
                        <b-button variant="primary" @click="pesquisar()" class="mt-4">
                            Pesquisar
                        </b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="12">
                    <b-form-group>
                        <b-form-checkbox
                                id="checkboxTodosContratos"
                                v-model="todosContratos"
                                @change="onChangeTodosContratos($event)"
                            >
                                Todos os contratos
                            </b-form-checkbox>
                    </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <b-alert variant="secondary" :show="exibirDadoFornecedor">
                            <div class="d-flex justify-content-between">
                                <div><b>{{ nomeFornecedor }}</b></div>
                                <div><b>{{ cnpjFornecedor }}</b></div>
                            </div>
                        </b-alert>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <app-tabela
                            :bordered="true"
                            :small="false"
                            :mostrarFiltro="false"
                            :itens="relatorios"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :mostrar-checkbox="true"
                            propriedade-id="id"
                            @selecao-alterada="onSelecaoAlterada">
                            <template slot="ativa" slot-scope="data">
                                <!-- <app-status
                                    :status="data.ativa ? 'SIM' : 'NÃO'"
                                ></app-status> -->
                            </template>
                            <template slot="atualizadoEm" slot-scope="data">
                                <span class="text-nowrap">{{
                                    data.atualizadoEm
                                        ? $moment(data.atualizadoEm).format('DD/MM/YYYY HH:mm')
                                        : '-'
                                }}</span>
                            </template>
                        <template slot="valorMensal" slot-scope="data">
                            <span class="text-nowrap">{{
                            data.valorMensal | currency
                            }}</span>
                        </template>
                        <template slot="valorTotalContrato" slot-scope="data">
                            <span class="text-nowrap">{{
                            data.valorTotalContrato | currency
                            }}</span>
                        </template>
                        <template slot="valorExecutado" slot-scope="data">
                            <span class="text-nowrap">{{
                            data.valorExecutado | currency
                            }}</span>
                        </template>
                        <template slot="acoes" slot-scope="data">
                            <btn-detalhar :relatorio="data"></btn-detalhar>
                        </template>
                        </app-tabela>
                    </b-col>
                </b-row>
            </b-card-body>
            <b-card-footer>
                <app-btn-voltar></app-btn-voltar>
                <b-button
                    variant="primary"
                    @click.stop="emitirExcel()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-file-o mr-2"></i> Emitir Excel</span
                    >
                </b-button>
                <b-button
                    variant="primary"
                    @click.stop="emitirPDF()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-file-pdf-o mr-2"></i> Emitir PDF</span
                    >
                </b-button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import RelatoriosServicos from './RelatoriosServicos'
import { ContractService } from '../../gestaojuridica/dados_complementares/relatorio-contrato-lai/services'
import GestaoJuridicaServicos from '../../gestaojuridica/GestaoJuridicaServicos'
import BtnDetalhar from '../../gestaojuridica/dados_complementares/relatorio-contrato-lai/BtnDetalhar.vue'

export default {
    data() {
        return {
            relatorios: [],
            fornecedores: [],
            fornecedor: null,
            nomeFornecedor: "",
            cnpjFornecedor: "",
            listaContratos: [],
            contrato: null,
            todosContratos: false,
            dataDe: null,
            dataAte: null,
            itensSelecionados: [],
            itensNaoSelecionados: [],
            campos: [
                {
                    key: 'atualizadoEm',
                    label: 'Atualizado em',
                    filterable: true,
                    sortable: true,
                    type: 'date',
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                {
                    key: 'numeroContrato',
                    label: 'Número do Contrato',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'anoContrato',
                    label: 'Ano',
                    filterable: true,
                    sortable: true,
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                {
                    key: 'objeto',
                    label: 'Objeto',
                    sortable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'valorTotalContrato',
                    label: 'Valor Total',
                    sortable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    sortable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'criadoPor',
                    label: 'Criado por',
                    sortable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },

    components: {
        ModelListSelect,
        BtnDetalhar
    },

    computed: {
        exibirDadoFornecedor() {
            return this.fornecedor !== null
        },

        exibirSelect() {
            return !(this.$route.params.cnpj)
        },

        validacaoData() {
            if (!this.dataDe || !this.dataAte) {
                return null
            }
            const dataDeObj = this.parseDate(this.dataDe)
            const dataAteObj = this.parseDate(this.dataAte)
            if (dataDeObj && dataAteObj) {
                return dataAteObj >= dataDeObj
            }
            return null
        }
    },

    mounted() {
        this.inicializarDatas()
        this.obterContratos()
        this.obterRelatoriosComFiltros()
    },

    methods: {
        inicializarDatas() {
            const hoje = new Date();
            const mesAnterior =
                hoje.getMonth() === 0 ? 11 : hoje.getMonth() - 1;

            const primeiroDia = new Date(hoje.getFullYear(), mesAnterior, 1);
            const ultimoDia = new Date(hoje.getFullYear(), mesAnterior + 1, 0);

            this.dataDe = this.formatarDataParaInput(primeiroDia);
            this.dataAte = this.formatarDataParaInput(ultimoDia);
        },

        formatarDataParaInput(data) {
            if (!data) return null
            const dia = String(data.getDate()).padStart(2, '0')
            const mes = String(data.getMonth() + 1).padStart(2, '0')
            const ano = data.getFullYear()
            return `${dia}/${mes}/${ano}`
        },

        onChangeTodosContratos(event) {
            this.todosContratos = event
            if (this.todosContratos) {
                this.contrato = null
            }
        },

        pesquisar() {
            if (this.validacaoData === false) {
                this.$toast.error(
                    'A data final deve ser maior ou igual à data inicial!',
                    'ERRO',
                    this.$toastConfig.error
                )
                return
            }
            this.obterRelatoriosComFiltros()
        },

        obterRelatoriosComFiltros() {
            if (this.validacaoData === false) {
                this.$toast.error(
                    'A data final deve ser maior ou igual à data inicial!',
                    'ERRO',
                    this.$toastConfig.error
                )
                return
            }

            const filtros = {}

            if (this.contrato && !this.todosContratos) {
                filtros.contratoId = this.contrato
            }

            if (this.dataDe) {
                filtros.dataDe = this.formatDateForAPI(this.dataDe)
            }

            if (this.dataAte) {
                filtros.dataAte = this.formatDateForAPI(this.dataAte)
            }

            this.$store.dispatch('addRequest')
            RelatoriosServicos.obterRelatoriosLAI(filtros).then((response) => {
                if (response) {
                    if (response.success) {
                        this.relatorios = response.data
                        if (this.contrato && !this.todosContratos) {
                            this.setarDadosContrato(this.contrato)
                        } else {
                            this.fornecedor = null
                            this.nomeFornecedor = ""
                            this.cnpjFornecedor = ""
                        }
                    } else {
                        this.$toast.error(
                            'Erro ao obter relatórios!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        setarDadosContrato(idContrato) {
            var contrato = this.listaContratos.find(f => f.idContrato === idContrato)

            if (contrato) {
                this.fornecedor = contrato.cnpj
                this.nomeFornecedor = contrato.fornecedor
                this.cnpjFornecedor = this.formatCNPJ(contrato.cnpj)
            }
        },

        emitirExcel() {
            if (this.validacaoData === false) {
                this.$toast.error(
                    'A data final deve ser maior ou igual à data inicial!',
                    'ERRO',
                    this.$toastConfig.error
                )
                return
            }

            const filtros = {}

            if (this.contrato && !this.todosContratos) {
                filtros.contratoId = this.contrato
            }

            if (this.dataDe) {
                filtros.dataDe = this.formatDateForAPI(this.dataDe)
            }

            if (this.dataAte) {
                filtros.dataAte = this.formatDateForAPI(this.dataAte)
            }

            this.$store.dispatch('addRequest')
            const itensNaoSelecionadosEnvio = this.itensNaoSelecionados &&
                this.relatorios &&
                this.itensNaoSelecionados.length === this.relatorios.length
                ? []
                : this.itensNaoSelecionados

            RelatoriosServicos.emitirRelatorioLAI(filtros, itensNaoSelecionadosEnvio)
                .then((response) => {
                    this.tratarRespostaRelatorio(response, 'xlsx')
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },

        tratarRespostaRelatorio(response, extensao) {
            if (!response) return

            if (response.noContent) {
                this.$toast.warning(
                    response.message,
                    'AVISO',
                    this.$toastConfig.warning
                )
            } else if (response.type === 'application/json') {
                this.$toast.error(
                    `Erro ao emitir relatório.`,
                    'ERROR',
                    this.$toastConfig.error
                )
            } else {
                this.fazerDownload(response, extensao)
            }
        },

        fazerDownload(response, extensao) {
            const dataFormatada = this.obterDataFormatada()
            const nomeArquivo = `Relatorio_LAI_${dataFormatada}.${extensao}`
            this.$download(response, nomeArquivo)
        },

        obterDataFormatada() {
            const hoje = new Date()
            const ano = hoje.getFullYear().toString()
            const mes = (hoje.getMonth() + 1).toString().padStart(2, '0')
            const dia = hoje.getDate().toString().padStart(2, '0')
            return ano + mes + dia
        },

        emitirPDF() {
            if (this.validacaoData === false) {
                this.$toast.error(
                    'A data final deve ser maior ou igual à data inicial!',
                    'ERRO',
                    this.$toastConfig.error
                )
                return
            }

            const filtros = {}

            if (this.contrato && !this.todosContratos) {
                filtros.contratoId = this.contrato
            }

            if (this.dataDe) {
                filtros.dataDe = this.formatDateForAPI(this.dataDe)
            }

            if (this.dataAte) {
                filtros.dataAte = this.formatDateForAPI(this.dataAte)
            }

            this.$store.dispatch('addRequest')
            const itensNaoSelecionadosEnvio = this.itensNaoSelecionados &&
                this.relatorios &&
                this.itensNaoSelecionados.length === this.relatorios.length
                ? []
                : this.itensNaoSelecionados

            RelatoriosServicos.emitirRelatorioLAIPDF(filtros, itensNaoSelecionadosEnvio)
                .then((response) => {
                    this.tratarRespostaRelatorio(response, 'pdf')
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },


        isArrayComDados(item)  {
            if (!Array.isArray(item))
                return false;
            else if (item.length === 0)
                return false;
            return true
        },

        formatCNPJ(valor) {
            if (!valor) return '';

            const raw = valor.replace(/[^a-zA-Z0-9]/g, '').slice(0, 14);

            let formatted = raw;

            if (raw.length > 2) {
                formatted = raw.slice(0, 2) + '.' + raw.slice(2);
            }
            if (raw.length > 5) {
                formatted = formatted.slice(0, 6) + '.' + formatted.slice(6);
            }
            if (raw.length > 8) {
                formatted = formatted.slice(0, 10) + '/' + formatted.slice(10);
            }
            if (raw.length > 12) {
                formatted = formatted.slice(0, 15) + '-' + formatted.slice(15);
            }
            return formatted;
        },

        formatDateForAPI(data) {
            if (!data) return null;

            const partes = data.split('/');
            if (partes.length === 3) {
                return `${partes[2]}-${partes[1]}-${partes[0]}`;
            }
            return null;
        },

        parseDate(data) {
            if (!data) return null;

            const partes = data.split('/');
            if (partes.length === 3) {
                const dia = parseInt(partes[0], 10);
                const mes = parseInt(partes[1], 10) - 1;
                const ano = parseInt(partes[2], 10);
                return new Date(ano, mes, dia);
            }
            return null;
        },

        async obterContratos() {
            this.$store.dispatch('addRequest')
            try {
                const response = await ContractService.getContracts(
                    GestaoJuridicaServicos
                )
                if (response && response.success) {
                    this.listaContratos = response.data
                    this.listaContratos = this.listaContratos.map((item) => {
                        return {
                            ...item,
                            textoFormatado: `${item.vcCodigoEstruturado} - ${item.fornecedor}`
                        }
                    })
                } else {
                    this.$toast.error(
                        'Erro ao obter lista de contratos!',
                        'ERRO',
                        this.$toastConfig.error
                    )
                }
            } catch (error) {
                this.$toast.error(
                    'Erro ao obter lista de contratos!',
                    'ERRO',
                    this.$toastConfig.error
                )
            } finally {
                this.$store.dispatch('removeRequest')
            }
        },

        onSelecaoAlterada(selecao) {
            this.itensSelecionados = selecao.selecionados
            this.itensNaoSelecionados = selecao.naoSelecionados
        }

    },
    watch: {
    }
}
</script>
